<div *transloco="let t; read: 'blocks.Block::Input::SignatureInput'"
     [id]="domId + slug"
     class="block-wrapper form-group d-flex flex-column {{block.styles.align}}">
  <div [class.disabled]="ineligible"
       [class.print-optimized]="blocksConfig.printOptimized"
       [class.is-invalid]="!ineligible && (!blocksConfig.editable || blocksConfig.preview) && (block.settings.validate || block.settings.required) && formControl?.invalid && formControl?.touched"
       class="wrap position-relative">

    <fieldset [id]="domId + slug + 'fieldset'">
      <div [class.mb-1]="!isOverlay"
           class="outer-signature-box">
        <div class="sr-only" [id]="slug + '-signature-box-label'" [innerHTML]="t('introduction')"></div>

        <div #signatureBox
             [class.pointer]="blocksConfig.submittable"
             [class.show-line]="!isOverlay"
             [class.signed]="isSigned() || isSignedDeprecated()"
             [gizmoDestinationInput]="formControl"
             [gizmoDestination]="this"
             [id]="slug + '-signature-box'"
             [attr.aria-labelledby]="slug + '-signature-box-label'"
             (click)="!blocksConfig.editable && blocksConfig.submittable ? onSign() : onClickSignatureBoxInEditor()"
             (keydown.enter)="!blocksConfig.editable && blocksConfig.submittable ? onSign() : onClickSignatureBoxInEditor()"
             class="signature-box d-flex align-items-end justify-content-center"
             tabindex="0">

          <ng-container *ngIf="isSigned() && (submitEventValue?.files?.[0] || localImage)">
            <img [src]="sanitizer.bypassSecurityTrustResourceUrl(localImage ? localImage : submitEventValue.files?.[0]?.url)">
          </ng-container>
          <!-- continue to support old format -->
          <ng-container *ngIf="isSignedDeprecated() && !isSigned()">
            <img [src]="sanitizer.bypassSecurityTrustResourceUrl($any(data)?.signature_image)">
          </ng-container>

          <div *ngIf="!blocksConfig.printOptimized"
               [class.signed]="isSigned() || isSignedDeprecated()"
               class="placeholder d-flex d-lg-none">
            {{t('tap_to_sign')}}
          </div>
          <div *ngIf="!blocksConfig.printOptimized"
               [class.signed]="isSigned() || isSignedDeprecated()"
               class="placeholder d-none d-lg-flex">
            <span>
              {{t('click_to_sign')}}
            </span>
            <div *ngIf="!block.settings.hide_name">
              <span *ngFor="let owner of owners" [title]="owner.participant.name || owner.participant.slot_name || t('unnamed')"
                    class="participant">
                {{owner.participant.name || owner.participant.slot_name || '[' + t('settings.participants') + ']'}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="blocksConfig.printOptimized && !isOverlay"
           class="description small">
        {{fieldOrderForPrintMode}}
      </div>

      <ng-container *ngIf="!blocksConfig.printOptimized">
        <ng-container *ngFor="let opt of block.settings.options_order; let i = index">
          <app-text-input *ngIf="block.settings['show_' + opt] && opt !== 'date'"
                          [block]="$any(getOptionalInput($any(opt)))"
                          [slug]="getTemporarySlug(opt)"
                          [data]="data[opt]"
                          (dataChange)="onChangeInput(opt, $event)"
                          class="d-block optional-input">
          </app-text-input>
          <app-date-input *ngIf="block.settings['show_' + opt] && opt === 'date'"
                          [block]="$any(getOptionalInput($any(opt)))"
                          [data]="data?.[opt]"
                          [slug]="getTemporarySlug(opt)"
                          [noFutue]="true"
                          (click)="(blocksConfig.editable || (blocksConfig.submittable && !blocksConfig.editable)) && onClickDateInput()"
                          (dataChange)="!blocksConfig.editable && onChangeInput(opt, $event)"
                          class="d-block date-input">
          </app-date-input>
        </ng-container>
      </ng-container>

      <small *ngIf="block.localizedHelpText(currentContentLocale, originalContentLocale,true)"
             [id]="domId + slug + 'helptext'"
             [class.text-danger]="blocksConfig.editable && blocksConfig.localizable && !block.localizedHelpText(currentContentLocale, originalContentLocale)"
             class="form-text text-muted d-block mt-n2"
             aria-hidden="true">
        {{block.localizedHelpText(currentContentLocale, originalContentLocale, true)}}
      </small>
    </fieldset>

    <pl-ineligibility-overlay *ngIf="ineligible" mode="sign"></pl-ineligibility-overlay>
  </div>
</div>
